{
  "familyId": "MET-LEN-CONTEXT",
  "questions": [
    {
      "id": "MET-LEN-CONTEXT-001",
      "familyId": "MET-LEN-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "lengte",
      "subSkill": "lengte_context",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker moet een ketting van 1,2 meter inkorten met 15 centimeter. Hoe lang wordt de ketting?",
      "options": ["1,05 m", "1,17 m", "0,90 m", "1,35 m"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rekenen met verschillende eenheden",
            "content": "Maak eerst de eenheden gelijk. 15 cm = 0,15 m. Dan: 1,2 m − 0,15 m = 1,05 m.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_context_aftrekken",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Eerst de eenheden gelijk maken: 15 cm = 0,15 m. Dan aftrekken: 1,2 m − 0,15 m = 1,05 m. Waarom eerst omrekenen? Omdat je alleen kunt aftrekken als beide getallen dezelfde eenheid hebben.",
        "solutionSteps": [
          "Maak eenheden gelijk: 15 cm = 0,15 m",
          "Reken: 1,20 m − 0,15 m = 1,05 m",
          "De ketting wordt 1,05 m lang"
        ],
        "distractorExplanations": {
          "0": "Goed! 1,2 m − 0,15 m = 1,05 m.",
          "1": "Je dacht waarschijnlijk dat 15 cm = 0,015 m. Maar 15 cm = 0,15 m (niet 0,015). Onthoud: 1 cm = 0,01 m, dus 15 cm = 15 × 0,01 = 0,15 m.",
          "2": "Je dacht waarschijnlijk dat 15 cm = 0,30 m. Maar 15 cm = 0,15 m. 30 cm zou 0,30 m zijn. Onthoud: deel door 100 om cm naar m om te rekenen.",
          "3": "Je dacht waarschijnlijk dat je moet optellen. Maar de ketting wordt INGEKORT, dus je trekt af. 1,2 − 0,15 = 1,05 m. Onthoud: inkorten = aftrekken."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.lengte-cm-naar-m-fout", "label": "Denkt dat 15 cm = 0,015 m (komma fout)", "optionIndex": 1 },
          { "id": "met.lengte-cm-naar-m-fout", "label": "Denkt dat 15 cm = 0,30 m", "optionIndex": 2 },
          { "id": "met.lengte-optellen-ipv-aftrekken", "label": "Telt op terwijl 'inkorten' aftrekken vraagt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-LEN-CONTEXT-002",
      "familyId": "MET-LEN-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "lengte",
      "subSkill": "lengte_context",
      "questionType": "multiple_choice",
      "question": "De afstand van school naar het zwembad is 2,5 km. Hoeveel meter is dat?",
      "options": ["25000 m", "250 m", "2500 m", "25 m"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "unit": "lengte",
            "from": "km",
            "to": "m",
            "value": 2.5,
            "label": "2,5 km omrekenen naar meter"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kilometers naar meters",
            "content": "1 km = 1000 m. Dus 2,5 km = 2,5 × 1000 = 2500 m. Bij × 1000 schuift de komma 3 plekken naar rechts.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_context_km_m",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "1 km = 1000 m. Dus 2,5 km = 2,5 × 1000 = 2500 m. Waarom ×1000? Omdat 'kilo' duizend betekent, dus kilometer = duizend meter. Bij ×1000 schuift de komma 3 plekken naar rechts: 2,500 → 2500.",
        "solutionSteps": [
          "Onthoud: 1 km = 1000 m (kilo = duizend)",
          "Vermenigvuldig: 2,5 × 1000 = 2500 m",
          "Check: 2500 m is ruim 6 rondjes op een atletiekbaan — realistisch ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 1 km = 10000 m. Maar 1 km = 1000 m. Onthoud: kilo = duizend, niet tienduizend.",
          "1": "Je dacht waarschijnlijk dat 1 km = 100 m. Maar 1 km = 1000 m. Onthoud: kilo = duizend.",
          "2": "Goed! 2,5 km = 2500 m. Kilo = duizend.",
          "3": "Je dacht waarschijnlijk dat 1 km = 10 m. Maar 1 km = 1000 m. 25 m is veel te kort — dat is maar een kwart van een voetbalveld."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.lengte-km-x10000", "label": "Denkt dat 1 km = 10000 m", "optionIndex": 0 },
          { "id": "met.lengte-km-x100", "label": "Denkt dat 1 km = 100 m", "optionIndex": 1 },
          { "id": "met.lengte-km-x10", "label": "Denkt dat 1 km = 10 m", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-LEN-CONTEXT-003",
      "familyId": "MET-LEN-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "lengte",
      "subSkill": "lengte_context",
      "questionType": "multiple_choice",
      "question": "Een tuinarchitect legt een pad aan van 8 meter en 40 centimeter. Hoeveel centimeter is het pad in totaal?",
      "options": ["8040 cm", "840 cm", "84 cm", "804 cm"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meters naar centimeters",
            "content": "1 m = 100 cm. Dus 8 m = 800 cm. Plus 40 cm = 840 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_context_m_cm",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "8 m = 8 × 100 = 800 cm. Plus 40 cm = 800 + 40 = 840 cm. Onthoud: van meter naar centimeter vermenigvuldig je met 100.",
        "solutionSteps": [
          "8 m = 8 × 100 = 800 cm",
          "Plus 40 cm = 800 + 40 = 840 cm"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 1 m = 1000 cm. Maar 1 m = 100 cm. 8 × 100 = 800, niet 8000. Onthoud: m → cm = × 100.",
          "1": "Goed! 8 m 40 cm = 840 cm.",
          "2": "Je dacht waarschijnlijk dat 1 m = 10 cm. Maar 1 m = 100 cm. 84 cm is minder dan 1 meter — veel te kort. Onthoud: m → cm = × 100.",
          "3": "Je dacht waarschijnlijk dat je de 40 gewoon achter de 8 plakt. Maar 8 m = 800 cm, niet 80 cm. Dus 800 + 40 = 840 cm."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.lengte-m-cm-x1000", "label": "Denkt dat 1 m = 1000 cm", "optionIndex": 0 },
          { "id": "met.lengte-m-cm-x10", "label": "Denkt dat 1 m = 10 cm", "optionIndex": 2 },
          { "id": "met.lengte-cijfers-aanplakken", "label": "Plakt cm-getal achter het m-getal", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-LEN-CONTEXT-004",
      "familyId": "MET-LEN-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "lengte",
      "subSkill": "lengte_context",
      "questionType": "multiple_choice",
      "question": "Een schilder heeft 3 planken van 1,5 meter nodig. Hoeveel meter plank heeft hij in totaal nodig?",
      "options": ["4,5 cm", "3,5 m", "5,0 m", "4,5 m"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met kommagetallen",
            "content": "3 planken × 1,5 m = 4,5 m. Je kunt ook rekenen: 3 × 1 = 3 en 3 × 0,5 = 1,5. Samen: 3 + 1,5 = 4,5 m.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_context_vermenigvuldigen",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "3 × 1,5 m = 4,5 m. Splits: 3 × 1 = 3 en 3 × 0,5 = 1,5. Samen: 3 + 1,5 = 4,5 m.",
        "solutionSteps": [
          "3 planken × 1,5 m per plank",
          "3 × 1 = 3 m",
          "3 × 0,5 = 1,5 m",
          "Totaal: 3 + 1,5 = 4,5 m"
        ],
        "distractorExplanations": {
          "0": "Je hebt de juiste berekening maar de verkeerde eenheid. 4,5 cm is veel te kort — de planken zijn 1,5 METER. Onthoud: let op de eenheid!",
          "1": "Je dacht waarschijnlijk dat je 3 + 0,5 moet rekenen. Maar je hebt 3 PLANKEN van 1,5 m, dus je vermenigvuldigt: 3 × 1,5 = 4,5 m. Onthoud: meerdere keren dezelfde lengte = vermenigvuldigen.",
          "2": "Je dacht waarschijnlijk dat 3 × 1,5 = 5. Maar 3 × 1,5 = 4,5. Check: 1,5 + 1,5 + 1,5 = 4,5.",
          "3": "Goed! 3 × 1,5 = 4,5 meter."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.lengte-eenheid-fout", "label": "Geeft antwoord in cm in plaats van m", "optionIndex": 0 },
          { "id": "met.lengte-optellen-ipv-vermenigvuldigen", "label": "Telt op in plaats van te vermenigvuldigen", "optionIndex": 1 },
          { "id": "met.lengte-decimaal-vermenigvuldigen-fout", "label": "Maakt rekenfout bij 3 × 1,5", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-LEN-CONTEXT-005",
      "familyId": "MET-LEN-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "lengte",
      "subSkill": "lengte_context",
      "questionType": "fill_in",
      "question": "Een hardloper rent 3 rondjes van 400 meter. Hoeveel kilometer heeft hij gerend? Typ je antwoord met een komma.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["1,2", "1.2", "1,2 km", "1.2 km"],
        "caseSensitive": false,
        "placeholder": "?,? km"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meters naar kilometers",
            "content": "3 × 400 m = 1200 m. 1200 m ÷ 1000 = 1,2 km. Bij ÷ 1000 schuift de komma 3 plekken naar links.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_context_m_km_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "3 rondjes × 400 m = 1200 meter. Reken om naar km: 1200 ÷ 1000 = 1,2 km. Onthoud: van m naar km deel je door 1000.",
        "solutionSteps": [
          "3 rondjes × 400 m = 1200 m",
          "1200 m ÷ 1000 = 1,2 km",
          "Check: 1,2 km = 1200 m ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.lengte-m-naar-km-fout", "label": "Maakt fout bij delen door 1000 of vergeet rondjes te vermenigvuldigen" }
        ]
      }
    }
  ]
}